var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0909 13.6364C37.8636 13.6364 40.8864 10.5909 40.8864 6.81818C40.8864 3.04545 37.8636 0 34.0909 0C30.3182 0 27.2727 3.04545 27.2727 6.81818C27.2727 10.5909 30.3182 13.6364 34.0909 13.6364ZM15.9091 13.6364C19.6818 13.6364 22.7045 10.5909 22.7045 6.81818C22.7045 3.04545 19.6818 0 15.9091 0C12.1364 0 9.09091 3.04545 9.09091 6.81818C9.09091 10.5909 12.1364 13.6364 15.9091 13.6364ZM15.9091 18.1818C10.6136 18.1818 0 20.8409 0 26.1364V31.8182H31.8182V26.1364C31.8182 20.8409 21.2045 18.1818 15.9091 18.1818ZM34.0909 18.1818C33.4318 18.1818 32.6818 18.2273 31.8864 18.2955C34.5227 20.2045 36.3636 22.7727 36.3636 26.1364V31.8182H50V26.1364C50 20.8409 39.3864 18.1818 34.0909 18.1818Z",
    fill: "black",
    fillOpacity: 0.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.b180a279f834f98799f6928ec60a5e5b.svg";
export { ForwardRef as ReactComponent };